import { format } from "date-fns";
import { Phone, Mail, Calendar, FileText, TrendingUp, RefreshCw } from "lucide-react";
import { cn } from "@/lib/utils";

const activityIcons = {
  call: Phone,
  email: Mail,
  meeting: Calendar,
  note: FileText,
  deal_update: TrendingUp,
  status_change: RefreshCw,
};

const activityColors = {
  call: "bg-blue-100 text-blue-600",
  email: "bg-lime-100 text-zinc-900",
  meeting: "bg-amber-100 text-amber-600",
  note: "bg-slate-100 text-slate-600",
  deal_update: "bg-emerald-100 text-emerald-600",
  status_change: "bg-rose-100 text-rose-600",
};

export default function ActivityFeed({ activities }) {
  if (!activities || activities.length === 0) {
    return (
      <div className="text-center py-12 text-slate-400">
        No recent activities
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {activities.map((activity) => {
        const Icon = activityIcons[activity.type] || FileText;
        return (
          <div key={activity.id} className="flex gap-4 items-start group">
            <div className={cn("p-2.5 rounded-xl shrink-0", activityColors[activity.type] || "bg-slate-100 text-slate-600")}>
              <Icon className="w-4 h-4" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-slate-900 truncate">{activity.title}</p>
              <p className="text-sm text-slate-500 truncate">{activity.related_name}</p>
              {activity.description && (
                <p className="text-sm text-slate-400 mt-1 line-clamp-2">{activity.description}</p>
              )}
            </div>
            <time className="text-xs text-slate-400 shrink-0">
              {format(new Date(activity.created_date), "MMM d")}
            </time>
          </div>
        );
      })}
    </div>
  );
}